import { useLanguageContext } from "../../../context/LanguageContext";
import BusinessCenterCompanyPage from "../../../pages/business_center_companies/business_center_company/BusinessCenterCompanyPage";
import { useBusinessCenterCompanyEditRouteValidator } from "../../validators/business_center_companies/BusinessCenterCompanyEditRouteValidator";
import { RouteConfig } from "../RouteConfig";
import useBusinessCenterCompaniesRouteConfig from "./BusinessCenterCompaniesRouteConfig";

/**
 * The route config which contains static information about the route
 * @returns {{ path, label, validator, getPage, getRouteElement }}
 */
function useBusinessCenterCompanyEditRouteConfig() {
  const { translate } = useLanguageContext();

  return new RouteConfig()
    .setPath(
      "/dashboard/business_center_companies/:business_center_company/edit"
    )
    .setLabel(
      translate("eva.main.entities.states.edit", [
        {
          key: "entities",
          value: translate("eva.main.entities.business_center_company"),
        },
      ])
    )
    .setValidator(useBusinessCenterCompanyEditRouteValidator())
    .setPage(<BusinessCenterCompanyPage />)
    .setParent(useBusinessCenterCompaniesRouteConfig());
}

export default useBusinessCenterCompanyEditRouteConfig;
